import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initDatadogRum } from './services/datadog';
import { initAnalytics } from './services/analytics';
import { initFeatureFlags } from './services/feature-flags';
import { initStaleChunkRecovery } from '@/lib/utils';
import './styles/fonts.css';
import './variables.css';
import './global.css';

initStaleChunkRecovery();
initDatadogRum();
initAnalytics();
initFeatureFlags();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
